export default {
  scheduleADemo: 'Schedule a demo',
  upgrade: 'Upgrade',
  upgradeDialogHeader: 'Upgrade plan',
  upgradeDialogTextInvite: 'Upgrade your plan to add more users.',
  upgradeDialogTextEdit: 'Upgrade your plan to assign a special role to a user',
};
